import { ApiEndpoints } from "@shared/api/api-endpoints";
import { bxApiClient, cxApiClient } from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import dayjs from "dayjs";
import { Consumer, mapToConsumer, OptionData } from "./types";
import { normalizeDate } from "@shared/utils/dateUtils";
export const getConsumers = async (searchData: string): Promise<Consumer[]> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `search-consumers`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
      qs.push("page", "1");
      qs.push("limit", "5");

      // Only add search_data if provided
      if (searchData?.trim()) {
        qs.push("search_data", searchData.trim());
      }
    }
  );

  const response = await bxApiClient.get(url);
  const data = response.data?.result;
  return data.map(mapToConsumer);
};

export const getBillTemplates = async (): Promise<OptionData[]> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bill-config-meta`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);

  const data = response.data?.result;
  return data.map((item: any) => ({
    value: item.id,
    label: item.configName,
    source: item.source,
  }));
};

export const updateConsumerSelection = async (payload: any, billId: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `single-bill-generation/${billId}`
  );
  const response = await bxApiClient.patch(url, payload);
  return response.data?.result;
};

export const submitConsumerSelection = async (payload: any) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `single-bill-generation`
  );
  const response = await bxApiClient.post(url, payload);
  return response.data?.result;
};

export const getBillData = async (billId: any): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `single-bill-generation/${billId}`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);

  return response.data?.result;
};

export const getConsumerCreditNote = async (consumerId: any): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `consumer-credit-note-data/${consumerId}`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);

  return response.data?.result;
};

export const getConsumerDetails = async (billId: any): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `consumer-details/${billId}`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);

  return response.data?.result;
};

export const getConsumerLatestBill = async (consumerNo: any): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "cx",
    `consumer-bill`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
      qs.push("consumer_id", consumerNo);
      qs.push("fetch_latest", "True");
      qs.push("bill_data", "True");
      qs.push("address_required", "True");
    }
  );
  const response = await cxApiClient.get(url);

  return response.data?.result;
};

export const getPlanData = async (id: any): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `get-plan-data/${id}`,
    (qs: QueryStringParameters) => {
      qs.push("is_consumer_count", "1");
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);

  return response.data?.result;
};

// export const getMeterDetails = async (
//   meterIds: any[],
//   invoiceStartDate: string,
//   invoiceEndDdate: string
// ): Promise<any> => {
//   console.log('invoiceStartDate',invoiceStartDate)
//   const REMOTE_UTILITY_ID = getRemoteUtilityId();
//   const url = ApiEndpoints.createUrlWithQueryParameters(
//     "bx",
//     "meter-reading-details",
//     (qs: QueryStringParameters) => {
//       for (let id of meterIds) {
//         qs.push("meter_id", id);
//       }
//       qs.push(
//         "invoice_start_date",
//         dayjs(invoiceStartDate).format("YYYY-MM-DD")
//       );
//       qs.push("invoice_end_date", dayjs(invoiceEndDdate).format("YYYY-MM-DD"));
//       qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
//     }
//   );
//     console.log('invoiceStartDate after conversion',invoiceStartDate)

//   const response = await bxApiClient.get(url);
//   console.log("Meter Details Response:", response.data);
//   return response.data.result;
// };
export const getMeterDetails = async (
  meterIds: any[],
  invoiceStartDate: string,
  invoiceEndDate: string
): Promise<any> => {
  try {

    const url = ApiEndpoints.createUrlWithQueryParameters(
      "bx",
      "meter-reading-details",
      (qs: QueryStringParameters) => {
        for (let id of meterIds) {
          qs.push("meter_id", id);
        }
        qs.push("invoice_start_date", invoiceStartDate);
        qs.push("remote_utility_id", getRemoteUtilityId());

        qs.push("invoice_end_date", invoiceEndDate);
    
      }
    );

    const response = await bxApiClient.get(url);
    console.log("Meter Details Response:", response.data);
    return response.data.result;
  } catch (error) {
    console.error("Error in getMeterDetails:", error);
    throw error;
  }
};

export const getMeteReadingStatus = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  console.log("api call:");
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    "choices/meter_meter_reading_status"
  );
  const response = await bxApiClient.get(url);
  return response.data.result;
};

export const getBillDetails = async (billId: any): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bill-details/${billId}`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );

  const response = await bxApiClient.get(url);
  return response.data?.result;
};

export const downloadBillTemplate = async (billId: string): Promise<Blob> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `render-dynamic-template/${billId}`
  );
  const response = await bxApiClient.get(url, {
    responseType: "blob",
  });
  return response.data;
};

export const approveBill = async (
  billId: any,
  draftId: string,
  isCommunicationSelected: boolean
) => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `single-bill-approve/${billId}`,
    (qs: QueryStringParameters) => {
      qs.push("bill_draft_id", draftId);
    }
  );
  const response = await bxApiClient.put(url, {
    send_communication: isCommunicationSelected,
  });
  return response.data?.result;
};
